import { Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { GuestOnly, RequireAuth } from '@/lib/auth';
import { AdminActivityPage, AdminChecksPage, AdminLedgerPage, AdminPurchasesPage, AdminScreenshotsPage } from '@/pages/admin/AdminListPages';
import { AdminBankAccountsPage } from '@/pages/admin/AdminBankAccountsPage';
import { AdminOverviewPage } from '@/pages/admin/AdminOverviewPage';
import { AdminPricingPage } from '@/pages/admin/AdminPricingPage';
import { AdminUserDetailPage } from '@/pages/admin/AdminUserDetailPage';
import { AdminUsersPage } from '@/pages/admin/AdminUsersPage';
import { LoginPage } from '@/pages/auth/LoginPage';
import { PasswordChangePage } from '@/pages/PasswordChangePage';
import { PasswordResetPage } from '@/pages/auth/PasswordResetPage';
import { AdminPasswordResetsPage } from '@/pages/admin/AdminPasswordResetsPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { BuyCoinsPage } from '@/pages/BuyCoinsPage';
import { CheckDetailPage } from '@/pages/CheckDetailPage';
import { ChecksPage } from '@/pages/ChecksPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { NewCheckPage } from '@/pages/NewCheckPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PurchasesPage } from '@/pages/PurchasesPage';
import { TransactionsPage } from '@/pages/TransactionsPage';
import { FlightStayPage } from '@/pages/FlightStayPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<GuestOnly><LoginPage /></GuestOnly>} />
      <Route path="/register" element={<GuestOnly><RegisterPage /></GuestOnly>} />
      <Route path="/password-reset" element={<GuestOnly><PasswordResetPage /></GuestOnly>} />

      <Route element={<RequireAuth><AppShell /></RequireAuth>}>
        <Route index element={<DashboardPage />} />
        <Route path="checks" element={<ChecksPage />} />
        <Route path="checks/new" element={<NewCheckPage />} />
        <Route path="checks/:id" element={<CheckDetailPage />} />
        <Route path="coins/buy" element={<BuyCoinsPage />} />
        <Route path="coins/purchases" element={<PurchasesPage />} />
        <Route path="coins/history" element={<TransactionsPage />} />
        <Route path="hotel-booking" element={<FlightStayPage />} />
        <Route path="account/password" element={<PasswordChangePage />} />

        <Route path="admin" element={<RequireAuth admin><AdminOverviewPage /></RequireAuth>} />
        <Route path="admin/password-resets" element={<RequireAuth admin><AdminPasswordResetsPage /></RequireAuth>} />
        <Route path="admin/purchases" element={<RequireAuth admin><AdminPurchasesPage /></RequireAuth>} />
        <Route path="admin/screenshots" element={<RequireAuth admin><AdminScreenshotsPage /></RequireAuth>} />
        <Route path="admin/users" element={<RequireAuth admin><AdminUsersPage /></RequireAuth>} />
        <Route path="admin/users/:id" element={<RequireAuth admin><AdminUserDetailPage /></RequireAuth>} />
        <Route path="admin/checks" element={<RequireAuth admin><AdminChecksPage /></RequireAuth>} />
        <Route path="admin/checks/:id" element={<RequireAuth admin><CheckDetailPage backTo="/admin/checks" backLabel="All checks" /></RequireAuth>} />
        <Route path="admin/ledger" element={<RequireAuth admin><AdminLedgerPage /></RequireAuth>} />
        <Route path="admin/activity" element={<RequireAuth admin><AdminActivityPage /></RequireAuth>} />
        <Route path="admin/pricing" element={<RequireAuth admin><AdminPricingPage /></RequireAuth>} />
        <Route path="admin/bank-accounts" element={<RequireAuth admin><AdminBankAccountsPage /></RequireAuth>} />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
